module.exports = __webpack_public_path__ + "img/Moduuli_2_liiketoimintamalli_asiakassegmentit.12960b8a.png";